import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";

// Define a type for the slice state

const clockInSlice = createSlice({
  name: "clockIn",

  initialState: {
    clockIn_time: "",
    clockIn_loder: false,
    can_checkin: true,
    last_checkIn_time: "",
  },
  reducers: {
    clockInReducer: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.clockIn_time = payload;
    },
    canClockIn: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.can_checkin = payload.can_checkin;
      state.last_checkIn_time = payload.last_checkIn_time;
    },
    setClockInLoader: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.clockIn_loder = payload;
    },
    resetClockIn: (state: any) => {
      state.clockIn_time = "";
    },
    resetCanClockIn: (state: any) => {
      state.can_checkin = true;
      state.last_checkIn_time = "";
    },
  },
});

export const {
  clockInReducer,
  resetClockIn,
  setClockInLoader,
  canClockIn,
  resetCanClockIn,
} = clockInSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default clockInSlice.reducer;
